/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Acwr_RangeInputs */

const en_exp_acwr_range = /** @type {(inputs: Exp_Acwr_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Below 0.8: undertraining, losing fitness. 0.8-1.3: sweet spot, safe progression. 1.3-1.5: caution, elevated risk. Above 1.5: danger zone, high injury risk.`)
};

const de_exp_acwr_range = /** @type {(inputs: Exp_Acwr_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unter 0,8: Untertraining, Fitnessverlust. 0,8–1,3: Sweet Spot, sichere Progression. 1,3–1,5: Vorsicht, erhöhtes Risiko. Über 1,5: Gefahrenzone, hohes Verletzungsrisiko.`)
};

/**
* | output |
* | --- |
* | "Below 0.8: undertraining, losing fitness. 0.8-1.3: sweet spot, safe progression. 1.3-1.5: caution, elevated risk. Above 1.5: danger zone, high injury risk." |
*
* @param {Exp_Acwr_RangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_acwr_range = /** @type {((inputs?: Exp_Acwr_RangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Acwr_RangeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_acwr_range(inputs)
	return de_exp_acwr_range(inputs)
});